import { Controller } from '@hotwired/stimulus';

// Connects to data-controller="turbo-modal"
export default class extends Controller {
  static targets = [
    'form', // Search form',
  ];
  connect() {
    console.log('tag controller connected');
    console.log('this.formtarget', this.formTarget);
  }
  submit() {
    console.log('submit');
    this.formTarget.requestSubmit();
  }
}
